import { MimeType } from '../types/mimeType';

const MIME_TYPES_TO_DISPLAY_AS_IMAGE = [MimeType.IMAGE_JPEG, MimeType.IMAGE_PNG, MimeType.IMAGE_GIF];

export const isImage = (type: MimeType) => MIME_TYPES_TO_DISPLAY_AS_IMAGE.includes(type);
